import logger, { LogValue } from './faro';

const createScopedLogger = (prefix: LoggerNamespace) => ({
  trace: <T>(message: string, value?: LogValue<T>) => logger.trace(`${prefix} ${message}`, value),
  debug: <T>(message: string, value?: LogValue<T>) => logger.debug(`${prefix} ${message}`, value),
  info: <T>(message: string, value?: LogValue<T>) => logger.info(`${prefix} ${message}`, value),
  warn: <T>(message: string, value?: LogValue<T>) => logger.warn(`${prefix} ${message}`, value),
  error: <T>(message: string, value?: LogValue<T>) => logger.error(`${prefix} ${message}`, value),
});

export enum LoggerNamespace {
  BREAKOUT_ROOMS = '[Breakout Rooms]',
  MATRIX_AUTH = '[Matrix Auth]',
  MATRIX_STORES = '[Matrix Stores]',
  ACTIVE_DEVICE = '[Active Device]',
  CALENDAR_SYNC = '[Calendar sync]',
  PERMISSIONS = '[Permissions]',
}

export const breakoutLogger = createScopedLogger(LoggerNamespace.BREAKOUT_ROOMS);
export const authLogger = createScopedLogger(LoggerNamespace.MATRIX_AUTH);
export const storesLogger = createScopedLogger(LoggerNamespace.MATRIX_STORES);
export const activeDeviceLogger = createScopedLogger(LoggerNamespace.ACTIVE_DEVICE);
export const calendarSyncLogger = createScopedLogger(LoggerNamespace.CALENDAR_SYNC);
export const permissionsLogger = createScopedLogger(LoggerNamespace.PERMISSIONS);
